import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { DotProps, DotSeparator, Typography, TypographyType } from '@lyearn/ui';

import { QuizPlayerQuestionHeaderProps } from './types';

const DOT_PROPS: DotProps = { size: 4 };
const TYPOGRAPHY_PROPS: TypographyType = { color: 'text-text-placeholder', variant: 'label-caps' };

//QP: QuizQuestionHeader
function QuizPlayerQuestionHeader(props: QuizPlayerQuestionHeaderProps) {
  const { t } = useTranslation();
  const { questionLabel, className } = props;

  return (
    <DotSeparator
      alignItems="center"
      className={cn('mb-10', className)}
      dotProps={DOT_PROPS}
      gapX={4}
      typographyProps={TYPOGRAPHY_PROPS}>
      <Typography>{t(questionLabel)}</Typography>
    </DotSeparator>
  );
}

export default QuizPlayerQuestionHeader;
